
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { VariantListOptionModel } from './Entities.GormCrm.VariantListOption';
import { VariantListTypes } from 'enums/VariantListTypes';
import { Model, ModelProperty } from 'models/Model';


export class VariantListModel extends Model<VariantListModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'variantListOptions', type: 'VariantListOptionModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new VariantListOptionModel }, properties: () => { return VariantListOptionModel.classProperties } },
		{ name: 'type', type: 'VariantListTypes' }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public deleted?: Date;
	public variantListOptions: VariantListOptionModel[];
	public type: VariantListTypes;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.deleted = undefined;
		this.variantListOptions = [];
		this.type = 0;
		
	}
	getProperties(){
		return VariantListModel.classProperties;
	}
}

